const path = require('path')

module.exports = {
    publicPath: './',
    // outputDir: 'wcba-3v3-analysis',//女子3v3
    // outputDir: 'wcba-report', //中国女篮名单解析
    // outputDir: 'wcba-nigeria-report',//尼日利亚女篮名单解析
    // outputDir: 'wcba-u23-report', //WCBA三人U23篮名单解析
    // outputDir: 'women-world-cup-qualifier', //WCBA三人U23篮名单解析
    // outputDir: 'women-world-cup-qualifie-summary',
    // outputDir: 'world-cup',
    // outputDir: 'world-cup-data',
    outputDir: 'women-world-cup-qualifie-summary',
    css: {
        loaderOptions: {
            less: {
                lessOptions: {
                    modifyVars: {
                        hack: `true; @import (reference) "${path.resolve('src/styles/index.less')}";`,
                        'btn-height-lg': '25px',
                        'table-padding-vertical': '20px',
                        'table-padding-horizontal': '12px',
                    },
                    javascriptEnabled: true,
                },
            },
        },
    },
}
